import { useReportsCtx } from 'containers/reports/ReportsContext'
import { useSidebarCtx } from 'containers/SidebarContext'
import 'css/Topbar.scss'
import mayaLogo from 'images/maya-logo.png'
import { useCallback, useContext, useRef, useState } from 'react'

import { useHistory } from 'react-router-dom'
import AccountMenu from './AccountMenu'
import OrganizationPicker from './OrganizationPicker'
import NotificationBell from 'components/Notifications/NotificationBell'
import BookmarkBar from 'components/Bookmarks/BookmarkBar'
import Breadcrumb from './Breadcrumb'
import { BookmarksContext } from 'containers/bookmarks/BookmarksContext'
import useConfirmation from 'containers/confirmation/useConfirmation'
import { isReportBookmark } from 'types'
import Feature from 'components/Feature'

const Topbar = ({
  organizations,
  isLoadingOrganization,
  organizationSlug,
  currentOrganization,
  user,
  page,
  clusterBreadcrumb,
}) => {
  const [accountMenuOpen, setAccountMenuOpen] = useState(false)
  const [saveSelectedBookmark, setSaveSelectedBookmark] = useState(false)
  const { isSidebarCollapsed, collapseSidebar } = useSidebarCtx()
  const { activeBookmark } = useContext(BookmarksContext)
  const { reportLoaded, report, embedReport, setReport } = useReportsCtx()
  const accountMenuRef = useRef(null)
  const { confirm } = useConfirmation()

  const history = useHistory()

  const handleClickLogo = () => {
    history.push('/')
  }

  const handleCollapseSidebar = () => {
    collapseSidebar((prev) => !prev)

    if (isSidebarCollapsed) {
      localStorage.setItem('isSideBarCollapsed', 'false')
    } else {
      localStorage.setItem('isSideBarCollapsed', 'true')
    }
  }

  const handleOpenAccountMenu = (e) => {
    e.stopPropagation()
    if (!accountMenuOpen) {
      document.addEventListener('mousedown', handleClickOutside)
    }
    setAccountMenuOpen((prev) => !prev)
  }

  const handleClickOutside = useCallback(
    (e) => {
      // Check if click is inside the modal (for mobile)
      const modalRoot = document.getElementById('modal-root')
      const isInsideModal = modalRoot && modalRoot.contains(e.target)

      if (
        accountMenuRef.current &&
        // @ts-ignore
        !accountMenuRef.current.contains(e.target) &&
        !isInsideModal
      ) {
        setAccountMenuOpen(false)
        document.removeEventListener('mousedown', handleClickOutside)
      }
    },
    [setAccountMenuOpen]
  )

  const handleSaveBookmark = async () => {
    if (await confirm("Are you sure you want to save this bookmark?")) {
      setSaveSelectedBookmark(true)
    }
  }

  return (
    <div className="top-bar">
      <div className="left-side">
        <div
          className={`menu ${!isSidebarCollapsed ? 'open' : ''}`}
          onClick={handleCollapseSidebar}
        >
          <span className="material-icons-outlined">menu</span>
        </div>
        <div className="header">
          <div onClick={handleClickLogo} className="logo">
            <img src={mayaLogo} alt="Maya" />
          </div>
        </div>
      </div>
      {window.location.pathname.includes('dashboard') && activeBookmark && (
        <div className="middle">
          <Breadcrumb
            bookmarkName={activeBookmark?.name || ''}
            page={page}
            isDemo={
              activeBookmark && 'show_demo' in activeBookmark
                ? activeBookmark.show_demo
                : false
            }
          />
          {isReportBookmark(activeBookmark) && (
            <button
              data-tooltip="Save Bookmark"
              className="save-bookmark-btn tooltip bottom md"
              onClick={handleSaveBookmark}
            >
              <span className="material-icons-outlined">save</span>
            </button>
          )}
        </div>
      )}
      <div className="right-side">
        {window.location.pathname.includes('dashboard') && (
          <Feature feature="bookmarks" switchComponent={<></>}>
            <BookmarkBar
              organizationId={currentOrganization.id}
              embeddedReport={embedReport}
              reportSlug={report?.slug}
              saveSelectedBookmark={saveSelectedBookmark}
              setSaveSelectedBookmark={setSaveSelectedBookmark}
            />
          </Feature>
        )}
        <NotificationBell currentOrganization={currentOrganization} />
        <div
          ref={accountMenuRef}
          className={`account-menu ${
            accountMenuOpen ? 'open' : 'tooltip bottom md'
          }`}
          data-tooltip="Account"
        >
          <button className="account-menu-btn" onClick={handleOpenAccountMenu}>
            {user && user.email ? (
              <div className="user-avatar">
                {user.email.charAt(0).toUpperCase()}
              </div>
            ) : (
              <span className="material-icons-outlined">account_circle</span>
            )}
          </button>
          {accountMenuOpen ? (
            <AccountMenu
              currentOrganization={currentOrganization}
              setIsAccountMenuOpen={setAccountMenuOpen}
            />
          ) : (
            <></>
          )}
        </div>
        <OrganizationPicker
          organizations={organizations}
          isLoadingOrganization={isLoadingOrganization}
          organizationSlug={organizationSlug}
          currentOrganization={currentOrganization}
          page={page}
        />
      </div>
    </div>
  )
}

export default Topbar
